import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

/**
 * Leistungsarten für Zeitbuchungen (Standard zuerst, dann die freigegebenen
 * Alternativen — z. B. „IT Dienstleistung" / „IT Beratung" / „Office-Services").
 * Konfiguriert unter Einstellungen → Weclapp → Sync-Einstellungen. Eine Auswahl
 * wird nur angeboten, wenn es mehr als eine Option gibt; ohne Wahl gilt der Standard.
 */
export function useBookingArticles(enabled = true) {
  const query = useQuery({
    queryKey: ['weclapp', 'booking-articles'],
    queryFn: () => api.getWeclappBookingArticles(),
    enabled,
    staleTime: 5 * 60_000,
  });
  const options = query.data?.options ?? [];
  return {
    options,
    defaultArticleId: query.data?.defaultArticleId ?? null,
    /** true, sobald der Techniker wirklich etwas zu wählen hat. */
    hasChoice: options.length > 1,
    isLoading: query.isLoading,
  };
}
